<template>
  <authorization permissionKey="configuration_prescription" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Facilitadores de Receituário
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs background-color="transparent" color="secondary">
            <v-tab to="/configuracoes/receituario/intervalo">Intervalo</v-tab>
            <v-tab to="/configuracoes/receituario/quando">Quando</v-tab>
            <v-tab to="/configuracoes/receituario/periodo">Periodo</v-tab>
            <v-tab to="/configuracoes/receituario/orientacao">Orientação</v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <router-view />
    </v-container>
  </authorization>
</template>

<script>
  export default {
    name: "ConfigPrescription",
  };
</script>

<style lang="scss" scoped></style>
